export class BaseRepositoryBuilder {
  constructor(private repository, private resource?) {
  }

  build(resource = this.resource) {
    if (!resource) {
      throw new TypeError('BaseRepositoryBuilder#build(): Resource should be defined');
    }

    return new (this.repository)(resource);
  }
}
